// Header search (Ctrl/⌘K, plan 8.2.2): screens and glossary terms are searched in the browser; people and records
// come from here, permission-filtered: people need people.view and match only what the viewer may see (pseudonym
// otherwise); records match anyone's number, but text (title/project) only for the viewer's own records.
import { z } from 'zod';
import { Tool } from '../enums.js';
import { EpochMs, PersonRef, RecordRef, TeamRef } from '../common.js';

export const SearchQuery = z.object({ q: z.string().trim().min(1).max(60), limit: z.coerce.number().int().min(1).max(10).default(6) });
export const SearchResponse = z.object({
  people: z.array(z.object({ person: PersonRef, team: TeamRef.nullable(), title: z.string().nullable(), canOpen: z.boolean() })),
  records: z.array(z.object({ record: RecordRef, title: z.string().nullable(), tool: Tool, person: PersonRef, startedAt: EpochMs })),
});
export type SearchResponse = z.infer<typeof SearchResponse>;

export const searchSchemas = { SearchQuery, SearchResponse } as const;
